/* import __COLOCATED_TEMPLATE__ from './focus-trapper.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { A } from '@ember/array';
import { next } from '@ember/runloop';
const FOCUSABLE = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '*[tabindex]:not([tabindex="-1"])', '*[contenteditable]'];

/**
 * @param {Boolean}          disable when disable=true all focus management behavior is disabled.
 * @param {Boolean}          cycle When cycle=true, focus-trapper will cycle focus to the first focusable element
 *                                 when tabbing from the last focusable element, and will cycle focus to the last
 *                                 focusable element when shift-tabbing from the first focusable element.
 */
let FocusTrapperComponent = (_class = class FocusTrapperComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "element", _descriptor, this);
    _defineProperty(this, "allFocusableEl", A([]));
  }
  insertedElement(element) {
    this.element = element;
    // run this on every render in case the html contents change
    this.allFocusableEl.clear();
    this.allFocusableEl.addObjects(this.element.querySelectorAll(FOCUSABLE.join(', ')));
    // move focus into the focus-trapper if focus is outside the trapper
    this.refocus();
  }
  updated() {
    // run this on every render in case the html contents change
    this.allFocusableEl.clear();
    this.allFocusableEl.addObjects(this.element.querySelectorAll(FOCUSABLE.join(', ')));
  }
  keyDown(event) {
    if (event.keyCode === 9) {
      this.handleTab.call(this, event);
    }
  }
  focusOut(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.refocus();
    }
  }
  get canTrapFocus() {
    return this.allFocusableEl.length > 0;
  }
  handleTab(event) {
    const firstFocusableEl = this.allFocusableEl.firstObject;
    const lastFocusableEl = this.allFocusableEl.lastObject;
    const shouldCycleFocus = this.args.cycle;
    const shouldTrapFocus = !this.args.disable;
    const hasLostFocus = document && !this.element.contains(document.activeElement);
    if (shouldTrapFocus) {
      // if shift-tab and first-focusable, move focus to the last focusable
      if (event.target === firstFocusableEl && event.shiftKey) {
        event.preventDefault();
        if (shouldCycleFocus) next(lastFocusableEl, 'focus');
      }
      // if normal tab and last-focusable, move focus up to the first focusable
      if (event.target === lastFocusableEl && !event.shiftKey) {
        event.preventDefault();
        if (shouldCycleFocus) next(firstFocusableEl, 'focus');
      }
      if (hasLostFocus) {
        event.preventDefault();
        next(firstFocusableEl, 'focus');
      }
    }
  }
  refocus() {
    const firstFocusableEl = this.allFocusableEl.firstObject;
    const shouldTrapFocus = !this.args.disable;
    const hasLostFocus = document && !this.element.contains(document.activeElement);
    if (shouldTrapFocus && this.canTrapFocus && hasLostFocus) {
      next(firstFocusableEl, 'focus');
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "element", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "insertedElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertedElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusOut"), _class.prototype)), _class);
export { FocusTrapperComponent as default };